import Dashboard from '@/pages/Dashboard';

export default function MobileDashboardScreen() {
  return <Dashboard />;
}

